export const MY_CREATE_ACTIVITY = 1;
export const MY_PARTICIPATE_ACTIVITY = 2;
export const ALL_VENUE = 3;
export const CREATE_TOWER_PROJECT = 1;
export const CHANGE_TOWER_PROJECT = 2;
